import React from "react";

function Footer() {
    return <footer>
        <p>Ein Service der Nibyou GmbH</p>
    </footer>
}

export default Footer;